import type { CommentMention } from "@certa/types";
import type { UserMentionsListResponse } from "../services/userMentions.services";

/**
 * Transforms the API response to CommentMention format required by the frontend
 * Adds the 'u' prefix to user IDs to maintain compatibility with existing mention system
 */
export const userMentionsModelCreator = (
  response: UserMentionsListResponse
): CommentMention[] => {
  return response.map(user => ({
    id: `u${user.id}`, // Maintain u prefix for users
    display: user.full_name || user.email,
    isBot: user.email === "certa_bot@certa.in"
  }));
};
